<template>
  <div
    v-if="openCreateAnnotation"
    :class="
      variant === 'docked'
        ? 'flex items-center justify-end gap-1 border-b border-gray-100 px-2 py-1'
        : 'flex items-center gap-1'
    "
  >
    <button
      v-tooltip="'New annotation'"
      type="button"
      data-annotation-create
      data-tour="annotation-create"
      class="rounded-md p-1 text-gray-400 hover:text-gray-600"
      @click="openCreateAnnotation()"
    >
      <span class="sr-only">New annotation</span>
      <Icon name="plus" class="size-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/components/Core/Icon.vue";
import { useAnnotationCreateOpener } from "@/composables/useAnnotationCreateShortcut";

defineProps({
  // Docked variant renders as its own bordered secondary row under the tab
  // strip; overlay variant sits inline in the panel header.
  variant: { type: String, default: "overlay" },
});

const openCreateAnnotation = useAnnotationCreateOpener();
</script>
